import React, { PureComponent } from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import { useAppDispatch, useAppSelector } from '@/store/hooks';
import {
  goBack,
  selectDependantQueriesHistory,
  selectDependantQueriesIds,
} from '@/features/dependantQueries/dependantQueriesSlice';
import { useGetSavedQueriesQuery } from '@/features/savedQueriesWidget/apiSlice';
import { GeneralStylesWidgetContainer } from '@/features/savedQueriesWidget/GeneralStylesWidgetContainer';
import { SavedQueriesWidgetWithoutFetch } from '@/features/savedQueriesWidget/SavedQueriesWidget';
import { DEPENDANT_QUERIES_MODAL } from '@/features/savedQueriesWidget/widgetRenderContext.constants';
import { useDatasourceId } from '@/hooks';

const GoBackButton = styled.button`
  height: 42px;
  padding: 0 12px;
  font-size: 1.1em;
  border-radius: 23px;

  border: 1px solid #ddd;
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  line-height: 100%;
  cursor: pointer;
  white-space: nowrap;
  text-decoration: none;

  &:hover {
    background: #f7f7f7;
  }
`;

const DependantQueriesGoBackButton: React.FC = () => {
  const dependantQueriesHistory = useAppSelector(selectDependantQueriesHistory);
  const dispatch = useAppDispatch();
  if (dependantQueriesHistory.length === 0) return null;

  const handleGoBack = (e: React.MouseEvent) => {
    e.stopPropagation();
    dispatch(goBack());
  };

  return ReactDOM.createPortal(
    <GoBackButton onClick={handleGoBack}>Go back</GoBackButton>,
    document.getElementById('dependant-queries-go-back-button-container')!,
  );
};

const DependantQueriesModal: React.FC = () => {
  const datasourceId = useDatasourceId();
  const dependantQueriesIds = useAppSelector(selectDependantQueriesIds);

  const { data, isLoading } = useGetSavedQueriesQuery({
    datasourceId,
    seriesIds: dependantQueriesIds,
  });

  return (
    <GeneralStylesWidgetContainer>
      <SavedQueriesWidgetWithoutFetch
        mode={DEPENDANT_QUERIES_MODAL}
        onSelectQuery={({ series }) =>
          window.open(
            `/datasources/${datasourceId}/saved-queries/${series}`,
            '_blank',
          )
        }
        data={data}
        isLoading={isLoading}
      />
      <DependantQueriesGoBackButton />
    </GeneralStylesWidgetContainer>
  );
};

// eslint-disable-next-line camelcase
export default class DependantQueriesModal_WITH_DEPRICATED_STATIC_METHODS extends PureComponent {
  static modalType = () => 'DEPENDANT_QUERIES';

  static reducer = () => null;

  static title = () => 'Dependent queries';

  static includeSaveButton = () => false;

  render() {
    return <DependantQueriesModal />;
  }
}
